import { Link } from "@quintype/components";
import React, { useEffect, useState } from "react";
import "./cok-my-account-button.m.css";
import User from "../../../../../atoms/other-icons/User";

function CokMyAccountButton({ onAccountHandler }) {
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);
  return (
    <div styleName="wrapper" onClick={onAccountHandler}>
      {isMobile ? (
        <Link styleName="my-account-only-icon" target="_blank">
          <User color="#a5161c" width="10.31px" height="11.61px" />
        </Link>
      ) : (
        <Link styleName="my-account" target="_blank">
          <User color="#a5161c" width="10.31px" height="11.61px" />
          Profile
        </Link>
      )}
    </div>
  );
}

export default CokMyAccountButton;
